import { BusinessObjectBase } from './base';
import type { ProcessDesign } from './process-design';

export interface ProcessDesignActivityCountData {
  readonly id: string;
  readonly activityId?: string;
  readonly status?: string;
  readonly tokenCount?: number;
  readonly designUuid?: string;
  readonly processDesignId: number;
  readonly processDesign?: ProcessDesign;
}

export interface ProcessDesignActivityCount extends Readonly<ProcessDesignActivityCountData> {}
export class ProcessDesignActivityCount extends BusinessObjectBase {
  static readonly entityName = 'ProcessDesignActivityCount' as const;
  static readonly plural = 'process-design-activity-counts';

  // --- Static CRUD methods ---

  static async find(filter?: any): Promise<ProcessDesignActivityCount[]> {
    const url = `${this.baseUrl}/${this.plural}`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const results = await this.get<any[]>(url, params);
    return results.map((data) => new ProcessDesignActivityCount(data));
  }

  static async findOne(
    filter?: any,
  ): Promise<ProcessDesignActivityCount | null> {
    const url = `${this.baseUrl}/${this.plural}/find-one`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const data = await this.get<any>(url, params);
    return data ? new ProcessDesignActivityCount(data) : null;
  }

  static async findById(
    id: string,
    filter?: any,
  ): Promise<ProcessDesignActivityCount> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const data = await this.get<any>(url, params);
    return new ProcessDesignActivityCount(data);
  }

  static async create(
    data: Omit<ProcessDesignActivityCountData, 'id'>,
  ): Promise<ProcessDesignActivityCount> {
    const url = `${this.baseUrl}/${this.plural}`;
    const result = await this.post<any>(url, data);
    return new ProcessDesignActivityCount(result);
  }

  static async updateById(
    id: string,
    data: Partial<ProcessDesignActivityCountData>,
  ): Promise<ProcessDesignActivityCount> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    const result = await this.patch<any>(url, data);
    return new ProcessDesignActivityCount(result);
  }

  static async deleteById(id: string): Promise<boolean> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    try {
      await this.del<void>(url);
      return true;
    } catch {
      return false;
    }
  }
}
